import update from "immutability-helper";
import { IFailureAction, IState, ISuccessAction } from "interfaces/list-duck";
import { createActions, createReducer } from "reduxsauce";

export type TotemSchedulingSource = "CIF" | "FOB";

export interface TotemDelivery {
	code: number | string | null;
	gross_weight: number | string | null;
	origin?: string | null;
	destination?: string | null;
	carrier?: string | null;
	warehouse?: string | null;
}

export interface TotemScheduling {
	id: number;
	order_number?: number | string | null;
	weight?: number | string | null;
	deliveries?: TotemDelivery[];
	source: TotemSchedulingSource;
	starts_at: string | null;
	finishes_at: string | null;
	vehicle_plate: string | null;
	driver_document: string | null;
	driver_name: string | null;
	status: string;
	company?: unknown;
	carrier?: unknown;
	dock?: unknown;
	vehicle?: unknown;
	origin?: string | null;
	destination?: string | null;
}

const { Types, Creators } = createActions(
	{
		request: ["query", "onSuccess"],
		success: ["data", "date"],
		failure: ["error"],
		checkInRequest: ["payload", "onSuccess"],
		checkInSuccess: [],
		checkInFailure: ["error"],
		reset: [],
	},
	{ prefix: "LOOKUP_TOTEM_SCHEDULING_" },
);

export interface TotemSchedulingState extends IState {
	data: TotemScheduling[];
	date: string | null;
	checkingIn: boolean;
	checkInError: string | null;
}

const INITIAL_STATE: TotemSchedulingState = {
	data: [],
	date: null,
	checkingIn: false,
	checkInError: null,
	loading: false,
	error: null,
};

const request = (state: TotemSchedulingState) =>
	update(state, {
		loading: { $set: true },
		error: { $set: null },
	});

const success = (
	state: TotemSchedulingState,
	action: ISuccessAction & { date: string },
) =>
	update(state, {
		data: { $set: action.data as TotemScheduling[] },
		date: { $set: action.date },
		loading: { $set: false },
	});

const failure = (state: TotemSchedulingState, action: IFailureAction) =>
	update(state, {
		loading: { $set: false },
		error: { $set: action.error },
	});

const checkInRequest = (state: TotemSchedulingState) =>
	update(state, {
		checkingIn: { $set: true },
		checkInError: { $set: null },
	});

const checkInSuccess = (state: TotemSchedulingState) =>
	update(state, { checkingIn: { $set: false } });

const checkInFailure = (state: TotemSchedulingState, action: IFailureAction) =>
	update(state, {
		checkingIn: { $set: false },
		checkInError: { $set: action.error },
	});

export const totemScheduling = createReducer(INITIAL_STATE, {
	[Types.REQUEST]: request,
	[Types.SUCCESS]: success,
	[Types.FAILURE]: failure,
	[Types.CHECK_IN_REQUEST]: checkInRequest,
	[Types.CHECK_IN_SUCCESS]: checkInSuccess,
	[Types.CHECK_IN_FAILURE]: checkInFailure,
	[Types.RESET]: () => INITIAL_STATE,
});

export const LookupTotemSchedulingTypes = Types;
export const LookupTotemSchedulingActions = Creators;
